import { render, staticRenderFns } from "./QuestionUserInfo.vue?vue&type=template&id=c932b568&lang=pug"
import script from "./QuestionUserInfo.vue?vue&type=script&lang=js"
export * from "./QuestionUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports